import React from 'react';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import CompanyDropdown from 'features/company/components/CompanyDropdown';
import { useCurrentCompany } from 'hooks/useCurrentCompany';

const FinanceiroHeader = ({ 
  loading = false,
  onRefresh,
  isConsolidated = false,
  dadosConsolidados = null
}) => {
  const navigate = useNavigate();
  const { currentCompany } = useCurrentCompany();

  return (
    <div className="mb-8 relative">
      {/* Header principal - responsivo */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 space-y-4 sm:space-y-0">
        {/* Lado esquerdo - título e botão voltar */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center space-x-2 px-3 py-2 bg-[color:var(--surface-muted)] text-[color:var(--text-primary)] rounded-lg hover:bg-[color:var(--surface)] transition-colors self-start"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="text-sm font-medium">Voltar</span>
          </button>
          <div className="hidden sm:block h-6 w-px bg-[color:var(--border)]"></div>
          <h1 className="text-2xl sm:text-3xl font-bold text-[color:var(--text-primary)]">Área Financeira</h1>
        </div>
        
        {/* Lado direito - controles */}
        <div className="flex items-center space-x-3 relative z-30">
          <CompanyDropdown />
          <button
            onClick={onRefresh}
            disabled={loading}
            className="p-2 text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)] rounded-lg transition-colors disabled:opacity-50 bg-[color:var(--surface-muted)] hover:bg-[color:var(--surface)]"
            title="Atualizar dados"
          >
            <RefreshCw className={`h-5 w-5 ${loading ? 'animate-spin' : ''}`} />
          </button>
        </div>
      </div>
      
      {/* Descrição */}
      <div className="space-y-2">
        <p className="text-sm sm:text-base text-[color:var(--text-muted)]">
          Análise financeira e gestão de recursos • {currentCompany?.name || 'MOV Fibra'}
        </p>
        
        {/* Indicador de modo consolidado */}
        {isConsolidated && dadosConsolidados && (
          <div className="flex items-center space-x-2 text-sm text-[color:var(--accent)] bg-[color:var(--surface-muted)] px-3 py-2 rounded-lg">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: 'var(--accent)' }}></div>
            <span className="font-medium">
              Modo Consolidado • {dadosConsolidados.total_empresas} empresas
            </span>
            <span className="text-[color:var(--accent)]">
              ({dadosConsolidados.empresas?.map(emp => emp.nome).join(', ')})
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinanceiroHeader;



